interface ScheduleTimeCardProps {
  startDate: string
  endDate: string
  startTime: string
  endTime: string
  minExperienceDays: string
  minExperienceTime: string
}

function ScheduleTimeCard({
  startDate,
  endDate,
  startTime,
  endTime,
  minExperienceDays,
  minExperienceTime,
}: ScheduleTimeCardProps) {
  return (
    <div className="town-info-card">
      <h3 className="town-info-card__title">日程・時間</h3>
      <div className="town-schedule-row town-schedule-row--three">
        <div className="town-detail-field town-detail-field--inline">
          <div className="town-detail-field__label">開始日</div>
          <div className="town-detail-field__value">{startDate}</div>
        </div>
        <div className="town-detail-field town-detail-field--inline">
          <div className="town-detail-field__label">終了日</div>
          <div className="town-detail-field__value">{endDate}</div>
        </div>
        <div className="town-detail-field town-detail-field--inline">
          <div className="town-detail-field__label">最低体験日数</div>
          <div className="town-detail-field__value">{minExperienceDays}</div>
        </div>
      </div>

      <div className="town-schedule-row town-schedule-row--two">
        <div className="town-detail-field town-detail-field--inline">
          <div className="town-detail-field__label">開始時間</div>
          <div className="town-detail-field__value">{startTime}</div>
        </div>
        <div className="town-detail-field town-detail-field--inline">
          <div className="town-detail-field__label">終了時間</div>
          <div className="town-detail-field__value">{endTime}</div>
        </div>
      </div>

      <div className="town-detail-field">
        <div className="town-detail-field__label">最低体験時間（時間）</div>
        <div className="town-detail-field__value">{minExperienceTime}</div>
      </div>
    </div>
  )
}

export default ScheduleTimeCard
